import moment from "moment";

import { makeCrudStateSelectors } from "seneca-common/utils/apiStates";

import { feedbackCrudConfig } from "../consts";

const THROTTLE_FEEDBACK_DELAY_SECONDS = 30;

const getFeedbackMetaState = (state: any) => state.get("feedback").get("meta");

const feedbackCrudStateSelectors = makeCrudStateSelectors(
  getFeedbackMetaState,
  feedbackCrudConfig
);

const getCreateFeedbackSuccess = (state: any, id: string): boolean =>
  feedbackCrudStateSelectors.create.getSuccess(state, id);

const getCreateFeedbackError = (state: any, id: string): boolean =>
  feedbackCrudStateSelectors.create.getError(state, id);

const getCreateFeedbackLast = (state: any, id: string) =>
  feedbackCrudStateSelectors.create.getLast(state, id);

export const feedbackSuccessfullySent = (state: any, id: string): boolean => {
  // Even if the save errors show the user it was successful
  // don't want to show error sending feedback that might be reporting an error...
  const feedbackSent =
    getCreateFeedbackSuccess(state, id) || getCreateFeedbackError(state, id);

  const feedbackLastSent = getCreateFeedbackLast(state, id);

  // Throttle feedback for each modal
  const feedbackSentOverThrottleDelayAgo =
    moment().diff(moment(feedbackLastSent!), "seconds") <
    THROTTLE_FEEDBACK_DELAY_SECONDS;

  return feedbackSent && feedbackSentOverThrottleDelayAgo;
};
